export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20theatrical%20stage%20with%20warm%20red%20and%20amber%20spotlights%2C%20dramatic%20cinema%20atmosphere%2C%20velvet%20curtains%20in%20deep%20crimson%20tones%2C%20abstract%20motion%20blur%20of%20entertainment%20news%20headlines%2C%20luxurious%20dark%20background%20with%20golden%20accents%2C%20editorial%20photography%2C%20high%20contrast%2C%20mysterious%20and%20glamorous%20vibe%2C%20no%20text%20overlay%2C%20cinematic%20lighting&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="黑料吃瓜 - 娱乐八卦资讯平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-sm font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-line mr-1.5"></i>全网热门吃瓜平台
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight">
              黑料吃瓜
              <br />
              <span className="text-primary-300">你身边的吃瓜第一站</span>
            </h1>

            <p className="mt-3 text-lg md:text-xl text-white/70 font-heading">
              每日更新 · 精彩不停 · 高清在线
            </p>

            <p className="mt-5 text-sm md:text-base text-white/60 leading-relaxed max-w-xl mx-auto lg:mx-0">
              黑料吃瓜在线观看平台汇聚全网最新最热的吃瓜内容，提供黑料吃瓜高清视频、黑料吃瓜短视频在线播放服务。
              每日实时更新娱乐八卦、热点事件和独家爆料，支持高清流畅播放体验，让您随时随地掌握第一手吃瓜资讯。
              当前聚焦夏季娱乐热点，多位明星动态持续追踪中，精彩不容错过。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-1.5 text-white/80 text-sm">
                <i className="ri-timer-flash-line text-accent-400 text-base"></i>
                <span>每日更新 50+ 内容</span>
              </div>
              <div className="flex items-center gap-1.5 text-white/80 text-sm">
                <i className="ri-shield-check-line text-accent-400 text-base"></i>
                <span>高清流畅播放</span>
              </div>
              <div className="flex items-center gap-1.5 text-white/80 text-sm">
                <i className="ri-eye-line text-accent-400 text-base"></i>
                <span>全网热点追踪</span>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-flashlight-line"></i>
                立即围观
              </a>
              <a
                href="#app"
                onClick={(e) => { e.preventDefault(); handleScroll('#app'); }}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-line"></i>
                下载App
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden border-2 border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20collage%20of%20entertainment%20news%20and%20hot%20topics%2C%20abstract%20composition%20with%20warm%20red%20and%20golden%20accents%2C%20cinematic%20theme%20with%20dramatic%20lighting%2C%20modern%20editorial%20design%20aesthetic%2C%20no%20recognizable%20faces%2C%20no%20text%2C%20glowing%20warm%20tones%20on%20dark%20background%2C%20luxurious%20and%20eye-catching%20style%2C%20entertainment%20industry%20atmosphere%2C%20high%20production%20value&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                alt="黑料吃瓜 - 热门吃瓜内容聚合展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}